import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUserClaims as getUserClaimer } from "slices/authSlice";
import ModalLoading from "./LoadingModal";
import { Overlay } from "components/Overlay";
import { getAPIInstance, TokenHandler } from "api/axios.config";
import { getCurrentUser } from "services/currentUserService";
import { useOidc } from "@axa-fr/react-oidc";
import { getCurrentUserSettings } from "services/userSettingsService";
import { getCompany } from "services/companyService";
import { getApplicationSettings } from "services/applicationSettingsService";
import { getCurrentPeriod } from "services/transactionPeriodService";

const FreshLogin = ({ onComplete }) => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useOidc();

  const init = async () => {
    try {
      await getAPIInstance();

      await Promise.all([
        dispatch(getUserClaimer()),
        getCurrentUser(),
        getCurrentUserSettings(),
        getCompany(),
        getApplicationSettings(),
        getCurrentPeriod().then((data) => {
          if (data) {
            sessionStorage.setItem("sessionPeriod", JSON.stringify(data));
          }
        }),
      ]);
    } catch (err) {
      console.error("FreshLogin failed:", err);
    } finally {
      onComplete();
    }
  };

  useEffect(() => {
    if (isAuthenticated) init();
  }, [dispatch, isAuthenticated, onComplete]);

  return (
    <>
      <ModalLoading />
      <TokenHandler />
      <Overlay />
    </>
  );
};

export default FreshLogin;
